<template>
	<div class="core-uploader">
		<input
			class="core-uploader--input"
			:multiple="multiple"
			type="file"
			:accept="acceptedFileTypes"
			name="file"
			ref="fileControl"
			@change="handleFilesSelected">
	</div>
</template>


<script>
	import { mapActions, mapState } from 'vuex'

	import { VUEX_ATTACHMENT_QUEUE_MANAGER_ADD_FILES } from '@/store/constants/attachment_queue_manager'


	export default {
		name: 'core-uploader',

		props: {
			// Usage Type | CONST
			fileUsageType: {
				type: Number,
				required: true,
				default: null
			},

			/* fileUsageSubType: {
				type: Number,
				required: false,
				default: null
			}, */

			// Attach To | Array | An array of objects that specify model and modelId because
			//    we may need to attach to many things (Job, JobComment, etc)
			// Model | String | App\Job, App\JobComment (comes from a const)
			// Model Id | UUID
			attachTo: {
				type: [Object, Array], 
				required: true,
				default: {}
			},

			setProps: {
				type: Object,
				required: false,
				default: null
			},

			// Emit callback function when item(s) selected
			dispatchOnItemsSelected: {
				type: [Function, Promise],
				required: false,
				default: null
			},

			// Can select multiple files at once
			multiple: {
				type: Boolean,
				required: false,
				default: false
			},

			acceptedFileTypes: {
				type: Array,
				required: false,
				default: () => (['*'])
			},

			forceEnqueue: {
				type: Boolean,
				required: false,
				default: false
			}
		},

		data:() => ({
			files:             [],  // Files selected from picker
			processedFiles:    [],  // processed Files ready to be queued
			
			previewsPending:   [],  // array of preview still pending from Files
			previewLoadTicker: null, // ticker to check if File preview is loaded
		}),

		methods: {
			...mapActions({
				addFilesToAQM: VUEX_ATTACHMENT_QUEUE_MANAGER_ADD_FILES
			}),

			init() {
				this.$refs.fileControl.click()
			},

			loadFiles(files) {
				this.handleFilesSelected(files)
			},

			handleFilesSelected(event) {
                let self = this	// TODO: figure out scoping for proto

				// 1) Freshly read the files array in each change
                // there is a bug where sometimes fileControl appears as undefined
                // so grab files from the path
				
				if (event.target) {
					if (this.$refs.fileControl !== undefined) {
						this.files = this.$refs.fileControl.files
					} else {
						if ( event.path &&  event.path[0].files) {
							this.files = event.path[0].files
						}
					}
				} else {
					// Files handled from Drap/Drop
					this.files = event
				}

				// 2) Abort is no files are selected
				if (!this.files.length) return

                // 3)
				Array.prototype.forEach.call(this.files, (file, index) => {

					if (!this.validMimeType(file.type)) return

                    // TODO: eventually, we should try to move this to
					// the parent?
					let	data = {
						file:               file,
						name:               file.name, 
						filename:           file.name,
						usage_type:         this.fileUsageType,
						usage_sub_type:     null,
						progress:           {},
						status:             SILA_FILE_UPLOAD_STATUS_PENDING, // TODO: 'processing_status' or 'status'? How deep does this go?
						upload_status:      SILA_FILE_UPLOAD_STATUS_PENDING,
						processing_status:  null,
						attach_to:          this.attachTo,
						note:               null
					}

					// Assign props from incoming 'setProps Obj'
					if (this.setProps) Object.assign(data, this.setProps)


					// FILES LESS THAT 10MB get preview
                    if (file.size < 10 * 1024 * 1024) {
                        var fr = new FileReader()
						fr.onload = function() {
							Object.assign(data, { preview:fr.result })
							self.processedFiles.push(data)
						}

						fr.readAsDataURL(file)
						self.previewsPending.push(fr)

					} else {
						Object.assign(data, { preview:null })
						self.processedFiles.push(data)

						self.previewsPending.push(null)
					}
				})

				this.previewLoadTicker = setInterval(this.checkPreviewsReadyState, 100)
			},

			checkPreviewsReadyState() {
				let isPending = this.previewsPending.filter(item => {
					if (!item) return
					return item['readyState'] != 2 // is finished
				})

				if (isPending.length == 0) {
					clearInterval(this.previewLoadTicker)
					
					if (this.processedFiles.length > 0) {
						this.addFilesToAQM({files:this.processedFiles, forceEnqueue:this.forceEnqueue})
						
						if (this.dispatchOnItemsSelected)
							this.dispatchOnItemsSelected(this.processedFiles)

						// there is a bug where sometimes fileControl appears as undefined
						if (this.$refs.fileControl !== undefined) {
							this.$refs.fileControl.value = null
						}
						this.processedFiles = []
					}
				}
			},

			validMimeType(type) {
				// test if all
				if (this.acceptedFileTypes.includes('*')) return true

				// test direct match
				if (this.acceptedFileTypes.includes(type)) return true

				// test is mimetype/* wildcard
				let typeSplit = type.split('/')
				let wildcard = this.acceptedFileTypes.map(item => {
					let itemSplit = item.split('/')
					if (!itemSplit.includes('*')) return false
					if (typeSplit[0] == itemSplit[0]) return true
				})
				if (wildcard.includes(true)) return true

				// no match
				return false
			}
		}
	}
</script>

